module.exports = __webpack_public_path__ + "0b134b84be1b14d6fa535ddd6c252fe5.png";